import { styled } from '@mui/material/styles';
import { Button } from '@mui/material';
import useAuth from '../../hooks/useAuth';
import { isAdmin } from '../../utils/route-guard/roles-check';
import SynchronizeUserGroupsDialog from './SynchronizeUserGroupsDialog';
import { useState } from 'react';

const SynchronizeUserGroupsButtonContainer = styled('div')(({ theme }) => ({
    position: 'relative',
    top: 16,
    paddingLeft: 16,
    display: 'inline-block',
}));

const SynchronizeUserGroupsButton = () => {
    const { user } = useAuth();
    const isCurrentUserAdmin = isAdmin(user);
    const [isSynchronizeUserGroupsDialogOpen, setIsSynchronizeUserGroupsDialogOpen] = useState<boolean>(false);

    const handleSynchronizeUserGroupsDialogOpen = () => {
        setIsSynchronizeUserGroupsDialogOpen(true);
    };
    const handleSynchronizeUserGroupsDialogClose = () => {
        setIsSynchronizeUserGroupsDialogOpen(false);
    };

    if (isCurrentUserAdmin)
        return (
            <>
                <SynchronizeUserGroupsButtonContainer>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleSynchronizeUserGroupsDialogOpen}
                        style={{ marginBottom: '1rem' }}
                    >
                        Synchronize User Groups
                    </Button>
                </SynchronizeUserGroupsButtonContainer>
                {isSynchronizeUserGroupsDialogOpen && (
                    <SynchronizeUserGroupsDialog
                        isOpen={isSynchronizeUserGroupsDialogOpen}
                        handleClose={handleSynchronizeUserGroupsDialogClose}
                    />
                )}
            </>
        );
    return <></>;
};

export default SynchronizeUserGroupsButton;
